import React, { useState, useEffect } from "react";
import "./header.css";
import Logo from "../../assets/images/company_logo_svg.svg";
import WishlistIcon from "../../assets/images/wishlist.svg";
import CartIcon from "../../assets/images/cart.svg";
import ProfileIcon from "../../assets/images/profile.svg";
import SearchIcon from "@mui/icons-material/Search";
import SelectDrop from "../selectDrop/selectDrop";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { getBkendUrl } from "../../consts";

const bkendUrl = getBkendUrl();

export default function Header(){
    const [pdtCat, setPdtCat] = useState([
        'aaa', 'bbb', 'ccc'
    ]);

    // Warning: useEffect must not return anything besides a function, which is used for clean-up.

    // It looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:
    
    // useEffect(() => {
    //   async function fetchData() {
    //     // You can await here
    //     const response = await MyAPI.getData(someId);
    //     // ...
    //   }
    //   fetchData();
    // }, [someId]); // Or [] if effect doesn't need props or state
    
    // Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching

    const pdtCatList = [];

    const countryList = [];
    //"https://countriesnow.space/api/v0.1/countries/"

    
    return <>
    <header>
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-2">
                    <img src={Logo} id="logo"/>
                </div>
                {/* headerSearch start */}
                <div className="col-sm-5 d-flex align-items-center">
                    <div className="headerSearch d-flex align-items-center">
                        <SelectDrop data={pdtCatList} placeholder={'all categories'}>
                            <KeyboardArrowDownIcon className="arrow" />
                        </SelectDrop>
                        <div className="search ">
                            <input type="text" placeholder="search ..."/>
                            <SearchIcon className="searchIcon"/>
                        </div>
                    </div>
                </div>
                <div className="col-sm-5 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <div className="countrySelectDrop">
                            <LocationOnOutlinedIcon className="locationOnOutlinedIcon"/>
                            <SelectDrop data={countryList} placeholder={'your location'}>
                                <KeyboardArrowDownIcon className="arrow" />
                            </SelectDrop>
                        </div>
                        <ul className="list list-inline mb-0 headerTabs">
                            <li className="list-inline-item mb-0 d-flex align-items-center">
                                <span>
                                    <img src={WishlistIcon} id="Compare" className="mb-0"/>
                                    <span className="badge bg-success rounded-circle">3</span>
                                    Compare
                                </span>
                            </li>
                            <li className="list-inline-item mb-0 d-flex align-items-center">
                                <span>
                                    <img src={CartIcon} id="Cart" className="mb-0"/>
                                    <span className="badge bg-success rounded-circle">3</span>
                                    Cart
                                </span>
                            </li>
                            <li className="list-inline-item mb-0 d-flex align-items-center">
                                <span>
                                    <img src={WishlistIcon} id="WishList" className="mb-0"/>
                                    <span className="badge bg-success rounded-circle">3</span>
                                    WishList
                                </span>
                            </li>
                            <li className="list-inline-item mb-0 d-flex align-items-center">
                                <span>
                                    <img src={ProfileIcon} id="WishList" className="mb-0"/>
                                    Account
                                </span>
                            </li>
                        </ul>
                    </div>


                </div>
                {/* headerSearch end */}
            </div>
        </div>
    </header>
    </>
}